export default "__VITE_ASSET__C8mKa4GC__"